import React, { useState, useEffect, useRef, useMemo, useDeferredValue, Suspense, lazy } from 'react';
import { 
  Building2, Search, Filter, PlusCircle, Send, Copy, ShieldAlert, Sliders, 
  Users, Database, Layers, FileText, UserCheck, UserMinus, DollarSign, Award, 
  AlertOctagon, Info, HelpCircle, LogOut, CheckCircle2, RefreshCw, Briefcase, 
  ExternalLink, MessageSquare, Lock, User, CreditCard, Grid, ChevronLeft, 
  ChevronRight, ChevronDown, ChevronUp, Mail, ArrowLeft, Globe, Plus, Linkedin, 
  Twitter, Facebook, Instagram, Shield, BookOpen, Scale, Trash2, Edit3, Tag, 
  Calendar, Menu, X, Check, ArrowUp, ArrowUpRight, Download, Upload, Cpu, Sparkles,
  Paperclip, Trash, Eye, CheckCircle, AlertTriangle, Clock, Play, Pause, Square,
  BarChart2, TrendingUp, Compass, Zap, Phone, Share2, CornerDownRight, ThumbsUp,
  Bookmark, Star, CheckSquare, MessageCircle, AlertCircle, Key, ShieldCheck, LifeBuoy,
  CheckCheck, Loader2, ArrowRight, ThumbsDown, MessageSquareCode
} from 'lucide-react';
import { 
  User as UserType, Job as JobType, Proposal as ProposalType, Milestone as MilestoneType, 
  EscrowLedger as EscrowType, Dispute as DisputeType, Message as MessageType, 
  SystemSettings as SettingsType, ETLLog, BlogPost, EmailLog 
} from '../../types';
import { FREELANCER_CATEGORIES, BEST_FREELANCERS } from '../../data/bestFreelancers';
import { BLOG_POSTS, SEO_KEYWORDS } from '../../data/blogs';
import { SupportedCurrency } from '../../utils/geoCurrency';
import { cleanJobTitle } from '../../utils/cleanJobTitle';
import { extractPlainTextExcerpt } from '../../utils/jobSanitizer';
import { JobDescriptionRenderer } from '../JobDescriptionRenderer';
const UpworkHomePage = React.lazy(() => import('../UpworkHomePage').then(m => ({ default: m.UpworkHomePage })));

const JobDetailView = React.lazy(() => import('../JobDetailView').then(m => ({ default: m.JobDetailView })));

export const ListingsView: React.FC<any> = ({
  selectedRegion = 'All', setSelectedRegion = (..._a: any[]) => {},
  selectedEmploymentType = 'All', setSelectedEmploymentType = (..._a: any[]) => {},
  selectedFreelancerCategory = '', setSelectedFreelancerCategory = (..._a: any[]) => {}, 
  freelancerSearchQuery = '', setFreelancerSearchQuery = (..._a: any[]) => {}, 
  heroSearchInput = '', setHeroSearchInput = (..._a: any[]) => {}, 
  heroToggleMode = 'jobs', setHeroToggleMode = (..._a: any[]) => {},

  selectedBudgetRange = '', setSelectedBudgetRange = (..._a: any[]) => {}, 
  selectedSkill = '', setSelectedSkill = (..._a: any[]) => {}, 
  searchQuery = '', setSearchQuery = (..._a: any[]) => {}, 
  selectedSource = '', setSelectedSource = (..._a: any[]) => {}, 
  jobSortBy = 'date-desc', setJobSortBy = (..._a: any[]) => {}, 
  memoizedFilteredAndSortedJobs = [], 
  visibleJobsCount = 20, 
  calculateMatchScore = (..._a: any[]) => 0, 
  proposals = [], 
  selectedJob = null, setSelectedJob = (..._a: any[]) => {}, 
  jobFetchLoading = false, setJobFetchLoading = (..._a: any[]) => {}, 
  jobFetchError = false, setJobFetchError = (..._a: any[]) => {}, 
  setCurrentUser = (..._a: any[]) => {}, 
  expandedJobIds = {}, setExpandedJobIds = (..._a: any[]) => {}, 
  checkGateBlocked = (..._a: any[]) => false, 
  setProposalModal = (..._a: any[]) => {}, 
  setProposalBid = (..._a: any[]) => {}, 
  setCustomMilestones = (..._a: any[]) => {}, 
  setSharingJobId = (..._a: any[]) => {}, sharingJobId = null, 
  setShareSelectedTab = (..._a: any[]) => {}, shareSelectedTab = 'link', 
  getPlatformShareText = (..._a: any[]) => '', getShareLink = (..._a: any[]) => '', 
  setVisibleJobsCount = (..._a: any[]) => {}, 
  setActiveGeoRegion = (..._a: any[]) => {}, activeGeoRegion = 'US', 
  expandedAeqIndexes = {}, setExpandedAeqIndexes = (..._a: any[]) => {},

  jobs = [], filteredJobs = [], filterCategory = '', setFilterCategory = (..._a: any[]) => {}, 
  searchTerm = '', setSearchTerm = (..._a: any[]) => {},
  filterExperience = '', setFilterExperience = (..._a: any[]) => {}, 
  filterType = '', setFilterType = (..._a: any[]) => {}, 
  filterPaymentVerified = false, setFilterPaymentVerified = (..._a: any[]) => {}, 
  filterMinBudget = '', setFilterMinBudget = (..._a: any[]) => {}, 
  filterMaxBudget = '', setFilterMaxBudget = (..._a: any[]) => {},
  filterSort = 'newest', setFilterSort = (..._a: any[]) => {}, 
  currentUser = null, setAuthModal = (..._a: any[]) => {}, 
  setActiveJob = (..._a: any[]) => {}, setShowProposalModal = (..._a: any[]) => {},
  setShowJobDetailModal = (..._a: any[]) => {}, setShowPostJobModal = (..._a: any[]) => {}, 
  selectedCategory = '', setSelectedCategory = (..._a: any[]) => {}, 
  activeTab = 'listings', setActiveTab = (..._a: any[]) => {}, 
  formatPrice = (p: any) => typeof p === 'number' ? `$${p}` : String(p || ''), 
  selectedCurrency = 'USD', setSelectedCurrency = (..._a: any[]) => {}, 
  SUPPORTED_CURRENCIES = [], exchangeRates = {}, userLocation = null, 
  currencyNotif = null, savedJobIds = [], toggleSaveJob = (..._a: any[]) => {}, trackJobClick = (..._a: any[]) => {},
  selectedFreelancer = null, setSelectedFreelancer = (..._a: any[]) => {}, 
  freelancerSearch = '', setFreelancerSearch = (..._a: any[]) => {},
  freelancerCategoryFilter = '', setFreelancerCategoryFilter = (..._a: any[]) => {}, 
  freelancerMinRating = 0, setFreelancerMinRating = (..._a: any[]) => {},
  filteredFreelancers = [], handleShareJob = (..._a: any[]) => {}, 
  activeJobSlug = '', selectedJobDetail = null,
  jobDetailLoading = false, jobDetailError = false, 
  activeJob = null, isApplyingFromDetail = false, handleApplyFromDetail = (..._a: any[]) => {},
  showJobBoard = false, setShowJobBoard = (..._a: any[]) => {}, 
  setActiveJobSlug = (..._a: any[]) => {}, fetchJobDetailBySlug = (..._a: any[]) => {}, 
  renderJobMarkdown = (t: string) => t,
  freelancerActiveTab = 'all', setFreelancerActiveTab = (..._a: any[]) => {}, 
  renderStars = (..._a: any[]) => null, copyToClipboard = (..._a: any[]) => {}, 
  notify = (..._a: any[]) => {}
}) => {
  return (
            <div className="space-y-8 animate-fade-in">
              
              {activeJobSlug ? (
                <JobDetailView
                  jobSlug={activeJobSlug}
                  job={selectedJob}
                  isLoading={jobFetchLoading}
                  isError={jobFetchError}
                  currentUser={currentUser}
                  allJobs={jobs}
                  onBack={() => {
                    setActiveJobSlug('');
                    setSelectedJob(null);
                    setShowJobBoard(true);
                    setJobFetchError(false);
                    setJobFetchLoading(false);
                    window.history.pushState({}, '', '/jobs');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  onApply={(j) => {
                    setSelectedJob(j);
                    if (currentUser?.role === 'Freelancer') {
                      setProposalModal(true);
                    } else {
                      setAuthModal({ isOpen: true, mode: 'login' });
                    }
                  }}
                  onSelectJob={(j) => {
                    setActiveJobSlug(j.id);
                    setSelectedJob(j);
                    window.history.pushState({}, '', `/jobs/${j.id}`);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  formatPrice={formatPrice}
                  cleanJobTitle={cleanJobTitle}
                  notify={notify}
                />
              ) : !showJobBoard ? (
                /* UPWORK-STYLE HOME PAGE FOR HARRYDESK (License-Free Video, Emerald & Navy Branding, Category Grid, Escrow Badges) */
                <Suspense fallback={<div className="p-12 text-center text-slate-500 font-semibold">Loading HarryDesk Marketplace...</div>}>
                  <UpworkHomePage
                    setShowJobBoard={setShowJobBoard}
                    setActiveTab={setActiveTab}
                    setAuthModal={setAuthModal}
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    selectedSkill={selectedSkill}
                    setSelectedSkill={setSelectedSkill}
                    selectedFreelancerCategory={selectedFreelancerCategory}
                    setSelectedFreelancerCategory={setSelectedFreelancerCategory}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    freelancerSearchQuery={freelancerSearchQuery}
                    setFreelancerSearchQuery={setFreelancerSearchQuery}
                    heroSearchInput={heroSearchInput}
                    setHeroSearchInput={setHeroSearchInput}
                    heroToggleMode={heroToggleMode}
                    setHeroToggleMode={setHeroToggleMode}
                    currentUser={currentUser}
                    formatPrice={formatPrice}
                    selectedCurrency={selectedCurrency}
                    notify={notify}
                    jobsCount={jobs.length}
                    onSelectFreelancer={(freelancer) => {
                      if (currentUser?.role === 'Freelancer') {
                        notify("Please sign in as Employer to dispatch custom briefs.", "info");
                        return;
                      }
                      notify("Direct milestone brief initialized with expert " + freelancer.name, "success");
                    }}
                  />
                </Suspense>
              ) : (
                /* SECTION B: LIVE ACTIVE CLASSIFIED JOB DIRECTORY GRID */
                <div className="space-y-4 text-left">
                  {/* Compact Active Search Directory Header */}
                  <div className="bg-white border border-[#E2E8F0] rounded-2xl p-6 shadow-sm flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 text-left">
                    <div className="space-y-1">
                      <span className="text-[#2563EB] text-xs font-mono font-bold tracking-wider uppercase block">Verified Positions</span>
                      <h1 className="text-xl md:text-2xl font-black text-[#0B132B] font-display">Remote Jobs &amp; Freelance Projects - Escrow Protected</h1>
                      <p className="text-[#0B132B]/70 text-xs leading-normal font-sans max-w-xl">
                        Search and apply for audited developer roles secured by direct automated milestone escrow and transparent low platform fees.
                      </p>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        setShowJobBoard(false);
                        notify("Returned to marketplace home", "info");
                      }}
                      className="bg-slate-50 hover:bg-slate-100 text-[#0B132B] font-semibold text-xs px-4 py-2 rounded-full border border-[#E2E8F0] transition duration-200 cursor-pointer shrink-0"
                    > &larr; Back to Home
                    </button>
                  </div>
                  
                  {/* Category info bar */}
                  <div className="bg-white border border-brand-border rounded-xl p-5 shadow-3xs flex flex-wrap justify-between items-center gap-4">
                    <div>
                      <h2 className="text-base font-extrabold tracking-tight text-brand-dark">Categorized Remote Positions Directory</h2>
                      <p className="text-[11px] text-slate-500 mt-0.5">
                        Showing <strong className="text-brand-primary font-bold">{jobs.length}</strong> live remote crawling and platform contracts.
                      </p>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        setShowJobBoard(false);
                        notify("Returned to landing catalog", "info");
                      }}
                      className="text-slate-550 hover:text-[#3A41A5] py-1.5 px-3.5 border border-brand-border rounded-full text-[10px] font-bold hover:bg-slate-100 transition cursor-pointer font-sans bg-white"
                    > &larr; Back to Best Freelancers
                    </button>
                  </div>

                  {/* 2.6 /jobs Region Tabs */}
                  <div className="bg-white border border-brand-border rounded-xl p-3 shadow-3xs flex flex-wrap items-center justify-between gap-3">
                    <div className="flex items-center gap-1.5 overflow-x-auto pb-1">
                      {['All', 'Americas Remote', 'Europe & UK Remote', 'APAC & India Remote', 'Worldwide Remote'].map(reg => {
                        const isAct = (selectedRegion || 'All') === reg;
                        return (
                          <button
                            key={reg}
                            type="button"
                            onClick={() => {
                              setSelectedRegion(reg);
                              if (reg === 'All') {
                                window.history.pushState({}, '', '/jobs');
                              } else {
                                window.history.pushState({}, '', `/jobs?region=${encodeURIComponent(reg)}`);
                              }
                            }}
                            className={`px-3 py-1 rounded-full text-xs font-bold transition whitespace-nowrap cursor-pointer ${
                              isAct
                                ? 'bg-[#0284c7] text-white shadow-xs'
                                : 'bg-slate-50 text-slate-600 hover:bg-slate-100 border border-slate-200'
                            }`}
                          >
                            {reg}
                          </button>
                        );
                      })}
                    </div>

                    <div className="flex items-center gap-2 shrink-0">
                      <label htmlFor="employment-type-select" className="text-[10px] font-bold text-slate-500 uppercase tracking-wider font-mono">Type:</label>
                      <select
                        id="employment-type-select"
                        value={selectedEmploymentType || 'All'}
                        onChange={(e) => setSelectedEmploymentType(e.target.value)}
                        className="bg-slate-50 border border-slate-200 hover:border-brand-primary/50 text-slate-700 font-bold text-xs rounded-lg px-2.5 py-1 focus:outline-none focus:ring-1 focus:ring-brand-primary cursor-pointer transition capitalize"
                      >
                        <option value="All">All Types</option>
                        <option value="contract">Contract</option>
                        <option value="freelance">Freelance</option>
                        <option value="full-time">Full-Time</option>
                        <option value="part-time">Part-Time</option>
                      </select>
                    </div>
                  </div>

                  {/* Sorting & Quick Filter Info Bar */}
                  <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 bg-white border border-brand-border/60 rounded-xl p-4 text-xs font-medium text-slate-600 shadow-3xs" id="active-pipelines-sort-bar">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider font-mono">Active Pipeline:</span>
                      {selectedRegion && selectedRegion !== 'All' && (
                        <span className="bg-blue-50 text-blue-700 border border-blue-200 px-2.5 py-1 rounded-full text-[10px] font-bold flex items-center gap-1">
                          Region: {selectedRegion}
                          <button type="button" onClick={() => setSelectedRegion('All')} className="hover:text-red-650 font-bold ml-0.5 text-xs bg-transparent border-0 cursor-pointer">x</button>
                        </span>
                      )}
                      {selectedEmploymentType && selectedEmploymentType !== 'All' && (
                        <span className="bg-slate-100 text-slate-700 px-2.5 py-1 rounded-full text-[10px] font-bold flex items-center gap-1 capitalize">
                          Type: {selectedEmploymentType}
                          <button type="button" onClick={() => setSelectedEmploymentType('All')} className="hover:text-red-650 font-bold ml-0.5 text-xs bg-transparent border-0 cursor-pointer">x</button>
                        </span>
                      )}
                      {selectedCategory && (
                        <span className="bg-brand-light text-brand-dark px-2.5 py-1 rounded-full text-[10px] font-bold flex items-center gap-1">
                          {selectedCategory}
                          <button type="button" onClick={() => setSelectedCategory('')} className="hover:text-red-650 font-bold ml-0.5 text-xs bg-transparent border-0 cursor-pointer">x</button>
                        </span>
                      )}
                      {selectedSource && (
                        <span className="bg-slate-100 text-slate-700 px-2.5 py-1 rounded-full text-[10px] font-bold flex items-center gap-1">
                          Direct Exclusives
                          <button type="button" onClick={() => setSelectedSource('')} className="hover:text-red-650 font-bold ml-0.5 text-xs bg-transparent border-0 cursor-pointer">x</button>
                        </span>
                      )}
                      {selectedBudgetRange && (
                        <span className="bg-slate-100 text-slate-700 px-2.5 py-1 rounded-full text-[10px] font-bold flex items-center gap-1">
                          {selectedBudgetRange === 'under-1000' ? 'Under $1k' : selectedBudgetRange === '1000-5000' ? '$1k - $5k' : selectedBudgetRange === '5000-10000' ? '$5k - $10k' : 'Over $10k'}
                          <button type="button" onClick={() => setSelectedBudgetRange('')} className="hover:text-red-650 font-bold ml-0.5 text-xs bg-transparent border-0 cursor-pointer">x</button>
                        </span>
                      )}
                      {selectedSkill && (
                        <span className="bg-brand-light text-brand-dark px-2.5 py-1 rounded-full text-[10px] font-bold flex items-center gap-1">
                          Skill: {selectedSkill}
                          <button type="button" onClick={() => setSelectedSkill('')} className="hover:text-red-650 font-bold ml-0.5 text-xs bg-transparent border-0 cursor-pointer">x</button>
                        </span>
                      )}
                      {searchQuery && (
                        <span className="bg-slate-100 text-slate-700 px-2.5 py-1 rounded-full text-[10px] font-bold flex items-center gap-1">
                          Keyword: "{searchQuery}"
                          <button type="button" onClick={() => setSearchQuery('')} className="hover:text-red-650 font-bold ml-0.5 text-xs bg-transparent border-0 cursor-pointer">x</button>
                        </span>
                      )}
                      {!selectedCategory && !selectedSource && !selectedBudgetRange && !selectedSkill && !searchQuery && (!selectedRegion || selectedRegion === 'All') && (!selectedEmploymentType || selectedEmploymentType === 'All') && (
                        <span className="text-slate-400 text-[11px] font-mono">All verification pipelines loaded</span>
                      )}
                    </div>
                    
                    {/* Sorting dropdown component */}
                    <div className="flex items-center gap-2 shrink-0 w-full sm:w-auto justify-end">
                      <label htmlFor="pipeline-sort-select" className="text-[10px] font-bold text-slate-500 uppercase tracking-wider font-mono">Sort Pipelines:</label>
                      <select
                        id="pipeline-sort-select"
                        value={jobSortBy}
                        onChange={(e) => {
                          setJobSortBy(e.target.value);
                          const optText = (e.target.options && e.target.selectedIndex >= 0 && e.target.options[e.target.selectedIndex])
                            ? e.target.options[e.target.selectedIndex].text
                            : e.target.value;
                          notify(`Pipelines sorted by ${optText}`, 'info');
                        }}
                        className="bg-slate-50 border border-slate-200 hover:border-brand-primary/50 text-slate-700 font-bold text-xs rounded-lg px-3 py-1.5 focus:outline-none focus:ring-1 focus:ring-brand-primary cursor-pointer transition"
                      >
                        <option value="date-desc">Contract/Freelance &amp; Newest First</option>
                        <option value="date-asc">Date Created: Oldest First</option>
                        <option value="budget-desc">Budget: High to Low</option>
                        <option value="budget-asc">Budget: Low to High</option>
                        <option value="complexity-desc">Complexity: Expert First</option>
                        <option value="complexity-asc">Complexity: Entry First</option>
                      </select>
                    </div>
                  </div>

                  {/* Listings Mapped Directly */}
                  <div className="grid grid-cols-1 gap-3">
                    {(() => {
                      if (memoizedFilteredAndSortedJobs.length === 0) {
                        return (
                          <div className="bg-white rounded border border-slate-200 p-8 text-center text-xs font-medium text-slate-500">
                            No remote listings matches current filter inputs. Please reset filters or run the ETL worker sync.
                          </div>
                        );
                      }

                      const displayedJobs = memoizedFilteredAndSortedJobs.slice(0, visibleJobsCount);

                      const getDaysAgo = (dateStr?: string | number) => {
                        if (!dateStr) return 1;
                        const past = new Date(dateStr).getTime();
                        if (isNaN(past)) return 1;
                        const diffDays = Math.floor((Date.now() - past) / (1000 * 60 * 60 * 24));
                        return Math.max(1, diffDays);
                      };

                      return (
                        <>
                          {displayedJobs.map(job => {
                            const isExternal = !!(job.isExternal || (job.source && job.source !== 'organic' && job.source !== 'native' && job.source !== 'employer'));
                            const matchScore = currentUser ? calculateMatchScore(job.skillsRequired, currentUser.skills) : 0;
                            return (
                              <div 
                                key={job.id} 
                                className="bg-white hover:bg-brand-light/10 border border-brand-border hover:border-brand-primary/40 rounded-xl p-6 shadow-2xs hover:shadow-xs transition duration-200 space-y-3.5 text-left"
                                id={`job-card-${job.id}`}
                              >
                            <div className="flex justify-between items-start gap-4">
                              <div className="space-y-1">
                                {/* Tags Row */}
                                <div className="flex flex-wrap items-center gap-2">
                                  {currentUser?.role === 'Freelancer' && proposals.some(p => p.jobId === job.id) && (
                                    <span 
                                      className="bg-emerald-50 border border-emerald-250 text-emerald-850 px-2 py-0.5 rounded text-[9px] font-mono uppercase font-extrabold flex items-center gap-1 shadow-3xs animate-pulse"
                                      id={`job-applied-badge-${job.id}`}
                                    >
                                      <Check className="w-2.5 h-2.5 text-emerald-600 stroke-[3px]" /> Applied
                                    </span>
                                  )}

                                  {isExternal ? (
                                    <>
                                      <span className="bg-slate-100 text-slate-700 px-2.5 py-0.5 rounded text-[9px] font-mono uppercase font-bold">
                                        via {job.source || 'External'}
                                      </span>
                                      <span className="bg-blue-50 text-blue-700 border border-blue-200 px-2.5 py-0.5 rounded text-[9px] font-mono font-bold">
                                        {job.region || 'Worldwide Remote'}
                                      </span>
                                      <span className="bg-slate-100 text-slate-700 px-2.5 py-0.5 rounded text-[9px] font-mono font-semibold capitalize">
                                        {job.employmentType || job.type || 'Contract'}
                                      </span>
                                      <span className="bg-slate-50 text-slate-500 border border-slate-200 px-2 py-0.5 rounded text-[9px] font-mono font-semibold">
                                        Posted {getDaysAgo(job.createdAt || job.postedTime)}d ago
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <span className="bg-slate-50 border border-[#E2E8F0] text-[#0B132B] px-2 py-0.5 rounded text-[9px] font-mono uppercase font-bold flex items-center gap-1 shadow-3xs">
                                        <CheckCircle2 className="w-2.5 h-2.5 text-[#3B82F6]" /> [OK] Verified Escrow Secure
                                      </span>
                                      <span className="text-brand-primary text-[10px] font-mono font-bold uppercase tracking-wider bg-slate-50 border border-brand-border px-1.5 py-[1px] rounded">
                                        {job.category}
                                      </span>
                                    </>
                                  )}
                                </div>

                                <h3 className="font-extrabold text-base md:text-lg text-brand-dark mt-1">
                                  <a 
                                    href={`/jobs/${job.id}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setActiveJobSlug(job.id);
                                      setSelectedJob(job);
                                      setJobFetchLoading(false);
                                      setJobFetchError(false);
                                      window.history.pushState({}, '', `/jobs/${job.id}`);
                                      window.scrollTo({ top: 0, behavior: 'smooth' });
                                    }}
                                    className="hover:text-brand-primary hover:underline text-brand-dark"
                                  >
                                    {cleanJobTitle(job.title)}
                                  </a>
                                </h3>

                                <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-slate-500 font-mono mt-0.5">
                                  <span>Company: <a href={`/employer/${encodeURIComponent((job.clientName || 'company').toLowerCase().replace(/[^a-z0-9]+/g, '-'))}`} onClick={(e) => { e.preventDefault(); setSelectedJob(job); }} className="font-bold text-slate-705 hover:underline">{job.clientName || 'Company'}</a></span>
                                  <span className="text-slate-200">|</span>
                                  <span>{job.region || 'Worldwide Remote'}</span>
                                  <span className="text-slate-200">|</span>
                                  <span>Complexity: <span className="text-slate-800 font-bold">{job.complexity || 'Intermediate'}</span></span>
                                </div>
                              </div>

                              <div className="text-right shrink-0">
                                {isExternal ? (
                                  <>
                                    <span className="font-mono text-base md:text-lg font-extrabold text-brand-dark block">
                                      {job.salaryFormatted || 'Not specified'}
                                    </span>
                                    <span className="text-[9px] font-mono font-bold uppercase text-slate-600 bg-slate-100 border border-slate-200 px-2 py-0.5 rounded inline-block mt-1 tracking-wider">
                                      Compensation
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <span className="font-mono text-base md:text-lg font-extrabold text-brand-dark block">
                                      {formatPrice(job.budget)}
                                    </span>
                                    <span className="text-[9px] font-mono font-bold uppercase text-brand-primary bg-brand-light border border-brand-primary/20 px-2 py-0.5 rounded inline-block mt-1 tracking-wider">
                                      {job.type} budget
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>

                            {/* Description Excerpt - Clean plain-text, no raw HTML, with Read More */}
                            <div className="text-xs text-slate-600 leading-relaxed font-sans space-y-1">
                              {expandedJobIds && expandedJobIds[job.id] ? (
                                <div className="space-y-2 pt-1">
                                  <JobDescriptionRenderer 
                                    description={job.description} 
                                    compact={true}
                                    isExternal={isExternal}
                                  />
                                  <button
                                    type="button"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (typeof setExpandedJobIds === 'function') {
                                        setExpandedJobIds((prev: any) => ({ ...prev, [job.id]: false }));
                                      }
                                    }}
                                    className="text-[#0284c7] hover:text-[#0369a1] font-bold text-[11px] hover:underline cursor-pointer inline-flex items-center gap-0.5 mt-1"
                                  >
                                    Show Less &#9650;
                                  </button>
                                </div>
                              ) : (
                                <>
                                  <p className="line-clamp-2">
                                    {extractPlainTextExcerpt(job.description || '', 180)}
                                  </p>
                                  {(job.description || '').length > 130 && (
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        if (typeof setExpandedJobIds === 'function') {
                                          setExpandedJobIds((prev: any) => ({ ...prev, [job.id]: true }));
                                        }
                                      }}
                                      className="text-[#0284c7] hover:text-[#0369a1] font-bold text-[11px] hover:underline cursor-pointer inline-flex items-center gap-0.5"
                                    >
                                      Read More &#9660;
                                    </button>
                                  )}
                                </>
                              )}
                            </div>

                            {/* Required Skills Row */}
                            <div className="flex flex-wrap items-center justify-between gap-4 mt-3 pt-3 border-t border-slate-100">
                              <div className="flex flex-wrap gap-1.5">
                                {(job.skillsRequired || []).map((s: string, idx: number) => (
                                  <span 
                                    key={idx} 
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedSkill(s);
                                      notify(`Filtering by skill: ${s}`, 'success');
                                    }}
                                    className={`text-[10px] px-2.5 py-0.5 rounded-full font-medium transition cursor-pointer border ${
                                      selectedSkill.toLowerCase().trim() === (s || '').toLowerCase().trim()
                                        ? 'bg-brand-primary text-white border-brand-primary font-bold shadow-xs'
                                        : 'bg-slate-50 border-brand-border text-slate-700 hover:bg-slate-100'
                                    }`}
                                  >
                                    {s}
                                  </span>
                                ))}
                              </div>

                              <div className="flex items-center gap-1.5">
                                {currentUser && (
                                  <span className={`text-[10px] font-mono font-bold px-2 py-0.5 rounded border flex items-center gap-1 ${
                                    matchScore >= 80 ? 'bg-emerald-50 text-emerald-800 border-[#a7f3d0]' :
                                    matchScore >= 40 ? 'bg-amber-50 text-amber-700 border-amber-100' :
                                    'bg-slate-50 text-slate-500 border-slate-200'
                                  }`}>
                                    <UserCheck className={`w-3.5 h-3.5 ${matchScore >= 80 ? 'text-emerald-600' : matchScore >= 40 ? 'text-amber-500' : 'text-slate-400'}`} /> {matchScore}% FIT
                                  </span>
                                )}
                                
                                {isExternal ? (
                                  /* External Job Card Button: View Details (0 Connects, no bid modal) */
                                  <a
                                    href={`/jobs/${job.id}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setActiveJobSlug(job.id);
                                      setSelectedJob(job);
                                      setJobFetchLoading(false);
                                      setJobFetchError(false);
                                      window.history.pushState({}, '', `/jobs/${job.id}`);
                                      window.scrollTo({ top: 0, behavior: 'smooth' });
                                    }}
                                    className="bg-[#0284c7] hover:bg-[#0369a1] text-white px-5 py-2.5 rounded-full text-xs font-extrabold shadow-sm hover:shadow-md transition-all cursor-pointer inline-flex items-center gap-1"
                                  >
                                    View Details &rarr;
                                  </a>
                                ) : (
                                  /* Native Job Apply Button */
                                  currentUser?.role === 'Freelancer' && proposals.some(p => p.jobId === job.id) ? (
                                    <button 
                                      type="button"
                                      disabled
                                      className="bg-emerald-600 text-white px-5 py-2.5 rounded-full text-xs font-extrabold shadow-sm opacity-90 cursor-not-allowed border-0 flex items-center gap-1.5"
                                      id={`applied-job-indicator-${job.id}`}
                                    >
                                      <Check className="w-3.5 h-3.5 text-white stroke-[3px]" /> Applied
                                    </button>
                                  ) : (
                                    <button 
                                      type="button"
                                      onClick={() => {
                                        if (currentUser?.role === 'Employer') {
                                          notify("Employers cannot submit proposals.", "error");
                                          return;
                                        }
                                        if (checkGateBlocked('apply')) return;
                                        setProposalModal({ isOpen: true, job });
                                        setProposalBid(job.budget.toString());
                                        setCustomMilestones([
                                          { title: 'Project Implementation & Deployment', description: 'Deliver complete codebase and validation tests as requested.', budget: job.budget }
                                        ]);
                                      }}
                                      className="bg-[#E63946] hover:bg-[#D62830] text-white px-5 py-2.5 rounded-full text-xs font-extrabold shadow-md hover:shadow-lg hover:scale-[1.02] transform transition-all cursor-pointer border-0"
                                      id={`apply-job-trigger-${job.id}`}
                                    >
                                      Apply Now
                                    </button>
                                  )
                                )}

                                {/* Boost & Share Viral Loop Button */}
                                <button 
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSharingJobId(sharingJobId === job.id ? null : job.id);
                                    notify(sharingJobId === job.id ? 'Share panel closed' : 'Viral sharing workspace opened! Choose a template below to drive traffic.', 'info');
                                  }}
                                  className="bg-gradient-to-r from-blue-600 to-indigo-650 hover:from-blue-700 hover:to-indigo-750 text-white px-4 py-2.5 rounded-full text-xs font-extrabold shadow-md hover:shadow-lg transition-all flex items-center gap-1.5 cursor-pointer border-0"
                                >
                                  <Send className="w-3 h-3 text-white" /> Boost &amp; Share
                                </button>
                              </div>
                            </div>

                            {/* VIRAL SHARE DRAWER */}
                            {sharingJobId === job.id && (
                              <div
                                className="overflow-hidden mt-4 pt-4 border-t border-slate-100 space-y-4 animate-fade-in transition-all duration-200"
                              >
                                  <div className="bg-slate-50 border border-slate-150 rounded-2xl p-5 space-y-4 text-left">
                                    <div className="flex items-center justify-between">
                                      <h4 className="text-xs font-bold uppercase tracking-wider text-indigo-700 flex items-center gap-1.5">
                                        <Award className="w-4 h-4 text-indigo-600" />
                                        <span>Viral Sharing &amp; Recruitment Booster Loop</span>
                                      </h4>
                                      <button
                                        type="button"
                                        onClick={() => setSharingJobId(null)}
                                        className="text-slate-400 hover:text-slate-600 font-extrabold text-sm border-0 bg-transparent cursor-pointer"
                                      >
                                        x
                                      </button>
                                    </div>

                                    <p className="text-[11px] leading-relaxed text-slate-550">
                                      Boost recruitment velocity and earn referral commission by blasting this secure milestone-escrow contract across your active channels. Clicks are logged under your partner tracking cookie!
                                    </p>

                                    {/* Template Formats Grid */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                      
                                      {/* Left Column: Social Presets & Action Buttons */}
                                      <div className="space-y-3">
                                        <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block font-mono">1. Select Preset copy:</span>
                                        
                                        <div className="flex gap-1">
                                          {['LinkedIn', 'Twitter/X', 'Reddit'].map((platform) => (
                                            <button
                                              key={platform}
                                              type="button"
                                              onClick={() => {
                                                setShareSelectedTab(platform as any);
                                                notify(`Preset loaded for ${platform}`, 'success');
                                              }}
                                              className={`flex-1 py-1 px-2.5 rounded-lg text-[10px] font-bold transition-all border cursor-pointer ${
                                                shareSelectedTab === platform
                                                  ? 'bg-indigo-600 border-indigo-650 text-white shadow-2xs'
                                                  : 'bg-white border-slate-200 text-slate-650 hover:bg-slate-50'
                                              }`}
                                            >
                                              {platform}
                                            </button>
                                          ))}
                                        </div>

                                        {/* Copy Text Area */}
                                        <div className="relative">
                                          <textarea
                                            readOnly
                                            value={getPlatformShareText(job, shareSelectedTab)}
                                            rows={5}
                                            className="w-full text-[11px] font-sans bg-white border border-slate-250 rounded-xl p-3 outline-none text-slate-700 font-medium leading-relaxed resize-none"
                                          />
                                          <button
                                            type="button"
                                            onClick={() => {
                                              const textToCopy = getPlatformShareText(job, shareSelectedTab);
                                              navigator.clipboard.writeText(textToCopy);
                                              notify(` Copied ${shareSelectedTab} template copy to clipboard! Ready to share.`, 'success');
                                            }}
                                            className="absolute bottom-3 right-3 bg-slate-900 hover:bg-slate-950 text-white p-2 rounded-lg transition text-[10px] flex items-center gap-1 font-bold border-0 cursor-pointer shadow-sm"
                                            title="Copy to clipboard"
                                          >
                                            <Copy className="w-3 h-3 text-white" /> Copy
                                          </button>
                                        </div>

                                        {/* Dynamic Launcher Action Buttons */}
                                        <div className="flex gap-2">
                                          <a
                                            href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(getPlatformShareText(job, 'Twitter/X'))}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="flex-1 py-2 px-3 rounded-xl bg-[#1DA1F2] hover:bg-[#1a90da] text-white text-[10.5px] font-bold transition flex items-center justify-center gap-1 border-0 cursor-pointer text-center no-underline shadow-3xs"
                                          >
                                            <Twitter className="w-3.5 h-3.5 text-white" /> Post on X
                                          </a>
                                          <a
                                            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(getShareLink(job.id))}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="flex-1 py-2 px-3 rounded-xl bg-[#0077B5] hover:bg-[#00669c] text-white text-[10.5px] font-bold transition flex items-center justify-center gap-1 border-0 cursor-pointer text-center no-underline shadow-3xs"
                                          >
                                            <Linkedin className="w-3.5 h-3.5 text-white" /> Share LinkedIn
                                          </a>
                                        </div>
                                      </div>

                                      {/* Right Column: Visual Screenshot Card Mockup */}
                                      <div className="space-y-2">
                                        <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block font-mono">2. Visual Card Poster Preview:</span>
                                        
                                        <div className="bg-gradient-to-br from-indigo-900 via-[#0F172A] to-slate-900 border border-slate-800 rounded-2xl p-4.5 text-left relative overflow-hidden flex flex-col justify-between min-h-[170px] shadow-lg">
                                          <div className="absolute top-0 right-0 w-24 h-24 bg-red-500/10 rounded-full filter blur-xl pointer-events-none"></div>
                                          <div className="absolute bottom-0 left-0 w-24 h-24 bg-blue-500/10 rounded-full filter blur-xl pointer-events-none"></div>
                                          
                                          <div className="space-y-1.5 relative z-10">
                                            <div className="flex items-center gap-1.5">
                                              <div className="w-5 h-5 rounded-full bg-white/10 flex items-center justify-center text-[10px] font-bold text-white shrink-0">H</div>
                                              <span className="text-[9px] font-mono tracking-widest text-slate-300 font-extrabold uppercase">harrydesk.com</span>
                                            </div>
                                            
                                            <h5 className="text-sm font-black text-white leading-snug line-clamp-2">
                                              {job.title}
                                            </h5>
                                            
                                            <p className="text-[10px] text-slate-350 line-clamp-1">
                                              Client: {job.clientName} | {job.complexity} complexity
                                            </p>
                                          </div>

                                          <div className="flex items-end justify-between mt-3 pt-3 border-t border-white/5 relative z-10">
                                            <div>
                                              <span className="text-[8px] font-mono uppercase text-slate-400 block tracking-wider">Secure Escrow Budget</span>
                                              <span className="text-sm font-extrabold text-blue-400 font-mono">{formatPrice(job.budget)}</span>
                                            </div>
                                            <div className="bg-white/5 border border-white/10 rounded-lg px-2.5 py-1 text-[9px] font-bold text-indigo-300">
                                                0% Platform Fee
                                            </div>
                                          </div>
                                        </div>

                                        <p className="text-[9.5px] leading-normal text-slate-400 font-sans text-center">
                                           Take a quick screenshot of this badge and attach it to your social media post for 4x higher CTR!
                                        </p>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              )}
                              </div>
                          );
                        })}

                        {visibleJobsCount < memoizedFilteredAndSortedJobs.length && (
                          <div className="text-center pt-6 pb-2">
                            <button
                              type="button"
                              onClick={() => setVisibleJobsCount(prev => prev + 15)}
                              className="bg-[#3B82F6] hover:bg-blue-600 text-white text-xs font-bold py-3 px-8 rounded-xl shadow-xs transition duration-200 cursor-pointer inline-flex items-center gap-2"
                              id="load-more-jobs-btn"
                            >
                              <span>Load More Active Jobs ({memoizedFilteredAndSortedJobs.length - visibleJobsCount} remaining)</span>
                            </button>
                          </div>
                        )}
                      </>
                    );
                  })()}
                </div>

                </div>
              )}

              {/* === GEO GLOBAL COMPLIANCE, REGIONAL CONTRACTING, & CURRENCY HUB === */}
              <div className="bg-white border border-slate-200 rounded-3xl p-6 md:p-8 shadow-xs space-y-6 font-sans text-left mt-8" id="geo-compliance-hub">
                <div className="flex flex-col md:flex-row md:items-center justify-between border-b border-slate-100 pb-5 gap-4">
                  <div className="space-y-1">
                    <span className="text-[10px] font-mono font-bold tracking-widest uppercase bg-[#3B82F6]/5 border border-[#3B82F6]/20 text-[#3B82F6] px-3 py-1 rounded-full inline-block">
                       Generative & Geographic SEO Optimized
                    </span>
                    <h2 className="text-xl font-extrabold tracking-tight text-slate-900">
                      Global Contracting, Escrow Compliance, & Currency Hub (GEO Portal)
                    </h2>
                    <p className="text-xs text-slate-500 leading-relaxed max-w-2xl">
                      Select a geographic zone below to view localized escrow guidelines, technical W-8BEN/IR35 tax compliance frameworks, and Zoho CRM/Books system integration schemas.
                    </p>
                  </div>
                  <div className="flex items-center gap-1.5 self-start md:self-auto shrink-0 bg-slate-50 border border-slate-150 p-1.5 rounded-xl text-[11px] font-bold">
                    <span className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse"></span>
                    <span>AUTOMATED GEO DETECTED</span>
                  </div>
                </div>

                {/* Region Selection Tab Rails (Dynamic Interactive Interface) */}
                <div className="grid grid-cols-2 md:grid-cols-6 gap-2" id="geo-tab-select-rail">
                  {[
                    { id: 'AMER', label: ' AMER (US/CA)', desc: '1099, W-9, USD' },
                    { id: 'UK_IE', label: ' UK / IE', desc: 'IR35, VAT, GBP' },
                    { id: 'EEA', label: ' EEA (EU)', desc: 'GDPR, Reverse, EUR' },
                    { id: 'APAC', label: ' APAC (AU/NZ)', desc: 'GST, Audits, AUD' },
                    { id: 'IN_SA', label: ' India / SA', desc: 'LUT GST, FIRC, INR' },
                    { id: 'LATAM', label: ' LATAM', desc: 'Accounting, USD' }
                  ].map((region) => (
                    <button
                      type="button"
                      key={region.id}
                      onClick={() => {
                        setActiveGeoRegion(region.id as any);
                        notify(`Applied regional compliance model: ${region.label}`, "success");
                      }}
                      className={`flex flex-col items-center justify-center p-3 rounded-2xl border text-center transition cursor-pointer hover:bg-slate-50 hover:border-slate-300 ${
                        activeGeoRegion === region.id
                          ? 'bg-[#3A41A5] border-[#3A41A5] text-white hover:bg-[#3A41A5] hover:border-[#3A41A5]'
                          : 'bg-white border-slate-200 text-slate-705'
                      }`}
                      id={`geo-btn-${region.id}`}
                    >
                      <span className="text-xs font-black tracking-tight">{region.label}</span>
                      <span className={`text-[10px] font-semibold mt-0.5 ${activeGeoRegion === region.id ? 'text-white/80' : 'text-slate-450'}`}>
                        {region.desc}
                      </span>
                    </button>
                  ))}
                </div>

                {/* Animated Region Specification Box */}
                <div className="bg-slate-50/50 border border-slate-200/80 rounded-2xl p-5 md:p-6 space-y-6">
                  {/* Detailed compliance specifications per region */}
                  {activeGeoRegion === 'AMER' && (
                    <div className="space-y-4 animate-fade-in text-brand-dark">
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between border-b border-slate-200 pb-3 gap-2">
                        <div className="flex items-center gap-2">
                          <span className="text-lg"></span>
                          <h3 className="font-extrabold text-[#3A41A5] text-sm font-sans tracking-wide">
                            North America Independent Contractor (1099-NEC) Compliance Framework
                          </h3>
                        </div>
                        <span className="text-[10px] font-black uppercase text-[#3B82F6] bg-[#3B82F6]/5 px-2.5 py-1 rounded-md border border-[#3B82F6]/20 font-sans">
                          SUPPORTED CURRENCY: USD / CAD
                        </span>
                      </div>
                      
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 text-xs">
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-200/70">
                          <h4 className="font-extrabold text-slate-800 flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> tax collection</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Automatically requests, formats, and validates formal digital W-9 forms for domestic US citizens and W-8BEN certifications for cross-border global developers. This preserves necessary independent tax classification audits.
                          </p>
                        </div>
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-200/70">
                          <h4 className="font-extrabold text-slate-800 flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span>  zoho workflow sync</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Triggers direct W-9/1099 ledger sheet creation in Zoho CRM & Zoho Books. Escrow milestones funded in Stripe connect immediately to standard general ledgers to ensure transparent end-of-year corporate reporting.
                          </p>
                        </div>
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-400/20 shadow-2xs">
                          <h4 className="font-extrabold text-[#3A41A5] flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> Stripe milestone escrow</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Projects are backed by US-denominated balance accounts. Milestone funds are secured off-chain via safe credit checks and disbursed cleanly, shielding teams from costly legal actions and payment delays.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeGeoRegion === 'UK_IE' && (
                    <div className="space-y-4 animate-fade-in text-brand-dark">
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between border-b border-slate-200 pb-3 gap-2">
                        <div className="flex items-center gap-2">
                          <span className="text-lg"></span>
                          <h3 className="font-extrabold text-[#3A41A5] text-sm font-sans tracking-wide">
                            United Kingdom & Ireland IR35 Delimitation Framework
                          </h3>
                        </div>
                        <span className="text-[10px] font-black uppercase text-indigo-705 bg-indigo-50 px-2.5 py-1 rounded-md border border-indigo-200/50 font-sans">
                          SUPPORTED CURRENCY: GBP / EUR
                        </span>
                      </div>
                      
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 text-xs">
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-200/70">
                          <h4 className="font-extrabold text-slate-800 flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span>  outside-ir35 routing</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Ensures all milestone contract descriptions strictly utilize substitution clauses and define project milestones as business outcomes rather than hourly labor, keeping British freelancers securely Outside-IR35.
                          </p>
                        </div>
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-200/70">
                          <h4 className="font-extrabold text-slate-800 flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> VAT invoice generation</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Generates VAT-compliant invoice pdf drafts dynamically through pre-connected Zoho Books accounts, factoring in regional VAT registrations and HMRC guidelines for local billing operations.
                          </p>
                        </div>
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-400/20 shadow-2xs">
                          <h4 className="font-extrabold text-[#3A41A5] flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> B2B settlement</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Protects payments through strict escrow balances. Funds are locked prior to sprint kickoffs, preventing Net-30 invoice outstanding debts and securing the work pipelines.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeGeoRegion === 'EEA' && (
                    <div className="space-y-4 animate-fade-in text-brand-dark">
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between border-b border-slate-200 pb-3 gap-2">
                        <div className="flex items-center gap-2">
                          <span className="text-lg"></span>
                          <h3 className="font-extrabold text-[#3A41A5] text-sm font-sans tracking-wide">
                            European Union (EEA) GDPR & Cross-Border Reverse Charge Guidelines
                          </h3>
                        </div>
                        <span className="text-[10px] font-black uppercase text-blue-705 bg-blue-50 px-2.5 py-1 rounded-md border border-blue-200/50 font-sans">
                          SUPPORTED CURRENCY: EUR
                        </span>
                      </div>
                      
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 text-xs">
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-200/70">
                          <h4 className="font-extrabold text-slate-800 flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> GDPR Privacy Vaults</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Stores developer KYC identification and contract negotiations under strict SSL end-to-end data transfer encryption protocols, respecting the EU Right to Be Forgotten and user data privacy rules.
                          </p>
                        </div>
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-200/70">
                          <h4 className="font-extrabold text-slate-800 flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> reverse charge VAT support</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Handles cross-border European engineering invoices by designating B2B services, applying reverse charge taxation rules properly within the VIES network system.
                          </p>
                        </div>
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-400/20 shadow-2xs">
                          <h4 className="font-extrabold text-[#3A41A5] flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> safe SEPA deposits</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Integrates frictionless SEPA direct bank payments through Stripe Connect, guaranteeing low-fee bank escrow deposits and rapid, secure multi-day releases.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeGeoRegion === 'APAC' && (
                    <div className="space-y-4 animate-fade-in text-brand-dark">
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between border-b border-slate-200 pb-3 gap-2">
                        <div className="flex items-center gap-2">
                          <span className="text-lg"></span>
                          <h3 className="font-extrabold text-[#3A41A5] text-sm font-sans tracking-wide">
                            Australia & New Zealand Independent Contracting Protections
                          </h3>
                        </div>
                        <span className="text-[10px] font-black uppercase text-orange-705 bg-orange-50 px-2.5 py-1 rounded-md border border-orange-200/50 font-sans">
                          SUPPORTED CURRENCY: AUD / NZD
                        </span>
                      </div>
                      
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 text-xs">
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-200/70">
                          <h4 className="font-extrabold text-slate-800 flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> contractor status audit</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Ensures contracts meet ATO definitions of an independent contractor based on commercial risk, delegation rights, and dedicated tool provision guidelines, preserving authentic B2B separation.
                          </p>
                        </div>
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-200/70">
                          <h4 className="font-extrabold text-slate-800 flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> Australian GST alignment</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Allows Australian clients and freelancers to lock business ABN details, automating GST charge inclusions for local services while maintaining clean tax ledger outputs.
                          </p>
                        </div>
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-400/20 shadow-2xs">
                          <h4 className="font-extrabold text-[#3A41A5] flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> secure AUD custody</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Frictionless escrow custody of project fees in dedicated Australian Dollar ledgers, neutralizing volatile currency conversion risks during remote tech development.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeGeoRegion === 'IN_SA' && (
                    <div className="space-y-4 animate-fade-in text-brand-dark">
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between border-b border-slate-200 pb-3 gap-2">
                        <div className="flex items-center gap-2">
                          <span className="text-lg"></span>
                          <h3 className="font-extrabold text-[#3A41A5] text-sm font-sans tracking-wide">
                            India Software Service Export (LUT GST & FIRC) compliance
                          </h3>
                        </div>
                        <span className="text-[10px] font-black uppercase text-[#3B82F6] bg-[#3B82F6]/5 px-2.5 py-1 rounded-md border border-[#3B82F6]/20 font-sans">
                          SUPPORTED CURRENCY: INR / USD
                        </span>
                      </div>
                      
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 text-xs">
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-200/70">
                          <h4 className="font-extrabold text-slate-800 flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> LUT (0% GST EXPORTS)</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Integrates Letter of Undertaking (LUT) support for Indian engineering exports, permitting developers to lawfully export tech code with 0% GST and skip complicated tax withholding schedules.
                          </p>
                        </div>
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-200/70">
                          <h4 className="font-extrabold text-slate-800 flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> FIRC Document Tracking</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Frictionless bank reconciliation pathway. Auto-synchronizes with Indian clearing codes so developers can trigger, claim, and save Foreign Inward Remittance Certificates for tax-exempt operations.
                          </p>
                        </div>
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-400/20 shadow-2xs">
                          <h4 className="font-extrabold text-[#3A41A5] flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> Low Platform Fees</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Avoid traditional 20% agency cuts. Keep maximum value with direct, secure milestone escrow channels and low fees.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeGeoRegion === 'LATAM' && (
                    <div className="space-y-4 animate-fade-in text-brand-dark">
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between border-b border-slate-200 pb-3 gap-2">
                        <div className="flex items-center gap-2">
                          <span className="text-lg"></span>
                          <h3 className="font-extrabold text-[#3A41A5] text-sm font-sans tracking-wide">
                            Latin America Remote Software Operations & Regional Invoicing
                          </h3>
                        </div>
                        <span className="text-[10px] font-black uppercase text-amber-705 bg-amber-50 px-2.5 py-1 rounded-md border border-amber-200/50 font-sans">
                          SUPPORTED CURRENCY: USD / BRL / MXN
                        </span>
                      </div>
                      
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 text-xs">
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-200/70">
                          <h4 className="font-extrabold text-slate-800 flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> double-trade routing</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Supports dual-currency contracts (USD escrow locking with local currency payouts). Automatically resolves high-currency transfer gaps for agencies out of Mexico, Brazil, Colombia, and Argentina.
                          </p>
                        </div>
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-200/70">
                          <h4 className="font-extrabold text-slate-800 flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> localized invoices</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Integrates templates matching local electronic invoicing mandates (such as NF-e in Brazil or CFDI in Mexico), preventing unexpected local business audit failures.
                          </p>
                        </div>
                        <div className="space-y-2 bg-white p-4 rounded-xl border border-slate-400/20 shadow-2xs">
                          <h4 className="font-extrabold text-[#3A41A5] flex items-center gap-1 text-[11px] uppercase tracking-wide text-brand-primary">
                            <span> continuous sync</span>
                          </h4>
                          <p className="text-slate-600 leading-relaxed text-[11.5px]">
                            Progressive Web App data caching assists nomads working across slow rural connections to log milestones and update pipeline boards without information dropouts.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* === SECURE COMPLIANCE & ESCROW FAQ HELP CENTER === */}
              <div className="bg-slate-50 border border-slate-200 rounded-3xl p-6 md:p-8 space-y-6 font-sans text-left mt-8" id="aeo-faq-hub">
                <div className="border-b border-slate-200 pb-5">
                  <span className="text-[10px] font-mono font-bold tracking-widest uppercase bg-blue-50 border border-blue-200 text-blue-700 px-3 py-1 rounded-full inline-block">
                     Secure Escrow Help Center
                  </span>
                  <h2 className="text-xl font-extrabold tracking-tight text-slate-900 mt-2">
                    Frequently Asked Questions &amp; Security Standards
                  </h2>
                  <p className="text-xs text-slate-500 leading-relaxed mt-1">
                    Review official guidelines regarding our zero-commission escrow system, remote contractor classification, and secure billing workflows.
                  </p>
                </div>

                {/* Structured Collapsible FAQ Accordion */}
                <div className="grid grid-cols-1 gap-3">
                  {[
                    {
                      q: "How does HarryDesk secure payments for remote developers and employers?",
                      a: "Before any development kickoff, the employer funds the designated milestone budget. Funds are securely verified and locked in specialized escrow balance vaults on Stripe Connect. Payouts are instantly triggered and transferred directly to the freelancer's linked bank account upon mutual completion approval."
                    },
                    {
                      q: "Are there any hidden fees, commission cuts, or platform taxes?",
                      a: "None whatsoever. HarryDesk operates on a 100% transparent 0% platform commission model. Freelancers and employers keep 100% of agreed milestone payouts. The only processing cost is the standard Stripe transaction fee (~2.9% + $0.30)."
                    },
                    {
                      q: "How do Stripe Connect milestones support dispute resolution?",
                      a: "Since funds must be fully secured in escrow before development starts, neither party is exposed to financial default. If a delivery conflict arises, the employer and freelancer can submit code artifacts and project definitions for direct, fast, administrative dispute arbitration."
                    },
                    {
                      q: "How does the platform handle contract billing and invoices?",
                      a: "We automatically generate digital, VAT-compliant invoices for every successfully released milestone. Invoices list tax registrations, contractor details, and Stripe transfer references, providing seamless integration with local general ledgers."
                    },
                    {
                      q: "How do companies post remote positions on HarryDesk?",
                      a: "Employers can manually publish roles within their client workspace, or synchronize career pages via RSS/XML sitemaps. Positions undergo automated classification scanning to ensure compliance with global independent contracting guidelines."
                    }
                  ].map((faq, idx) => {
                    const isOpen = expandedAeqIndexes[idx];
                    return (
                      <div 
                        key={idx} 
                        className={`border rounded-2xl transition-all duration-200 ${
                          isOpen 
                             ? 'bg-white border-[#3A41A5] shadow-xs' 
                             : 'bg-white/85 border-slate-200 hover:border-slate-300'
                        }`}
                      >
                        <button
                          type="button"
                          onClick={() => {
                            setExpandedAeqIndexes((prev) => ({
                              ...prev,
                              [idx]: !prev[idx]
                            }));
                          }}
                          className="w-full text-left p-4 md:p-5 flex items-center justify-between gap-4 cursor-pointer"
                          id={`aeo-faq-trigger-${idx}`}
                        >
                          <span className={`text-xs md:text-sm font-extrabold tracking-tight font-sans ${isOpen ? 'text-[#3A41A5]' : 'text-slate-900'}`}>
                            {faq.q}
                          </span>
                          <span className={`text-base shrink-0 transition-transform duration-200 font-mono font-bold ${isOpen ? 'text-[#3A41A5] rotate-45' : 'text-slate-400'}`}>
                             
                          </span>
                        </button>
                        
                        {isOpen && (
                          <div className="px-4 md:px-5 pb-5 pt-0 border-t border-slate-100 animate-fade-in text-left">
                            <p className="text-xs text-slate-600 leading-relaxed font-sans pt-3.5">
                              {faq.a}
                            </p>
                            <div className="flex flex-wrap gap-1.5 mt-3.5 pt-3.5 border-t border-slate-50">
                              <span className="text-[9px] font-mono font-bold bg-slate-50 border border-slate-150 text-slate-500 px-2 py-0.5 rounded-md">
                                [OK] VERIFIED ESCROW LEDGER
                              </span>
                              <span className="text-[9px] font-mono font-bold bg-blue-50 border border-blue-100 text-blue-600 px-2 py-0.5 rounded-md">
                                [OK] SECURED VIA STRIPE
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>

            </div>
  );
};
